import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';
import IconStar from '@/assets/icons/heroIcons/Star.svg';
import { ContentContainer } from '@/components/layout';
export const DXHeroes = () => {
  const $ = _c(19);
  const {
    t
  } = useTranslation("forEshops");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="-ml-12 flex w-full items-center justify-center lg:-ml-20 lg:max-w-148 lg:shrink-0"><Image src="/images/sections/forEshops/dxheroes.png" width={630} height={308} alt="DX Heroes" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-row justify-center gap-1.5 text-orange-500 lg:justify-start"><IconStar className="h-5 w-5" /><IconStar className="h-5 w-5" /><IconStar className="h-5 w-5" /><IconStar className="h-5 w-5" /><IconStar className="h-5 w-5" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("integration.box.text");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h3 className="text-lg font-bold lg:text-3xl">{t2}</h3>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("integration.box.author.name");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <strong className="font-semibold">{t4}</strong>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("integration.box.author.job");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t7) {
    t8 = <p className="text-xs lg:text-base">{t5}{t6}{t7}</p>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t8) {
    t9 = <ContentContainer className="flex flex-col items-center gap-8 rounded-4xl bg-blue-500 px-6 py-8 lg:flex-row lg:gap-10 lg:px-20 lg:py-16">{t0}<div className="flex flex-col items-center gap-4 text-center text-white lg:items-start lg:gap-6 lg:text-left">{t1}{t3}{t8}</div></ContentContainer>;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};